import { Volume2, VolumeX } from 'lucide-react';
import { useTextToSpeech } from '../../hooks/useTextToSpeech';
import { useApp } from '../../context';

interface ReadAloudButtonProps {
  text: string;
  label?: string;
}

export function ReadAloudButton({ text, label = 'Read aloud' }: ReadAloudButtonProps) {
  const { state } = useApp();
  const { speak, stop, isSpeaking, isSupported } = useTextToSpeech();

  // Only show when text-to-speech is enabled
  if (!state.settings.textToSpeech || !isSupported) return null;

  return (
    <button
      onClick={() => isSpeaking ? stop() : speak(text)}
      aria-label={isSpeaking ? 'Stop reading' : label}
      title={isSpeaking ? 'Stop reading' : label}
      className="read-aloud-btn"
    >
      {isSpeaking ? <VolumeX size={16} /> : <Volume2 size={16} />}
    </button>
  );
}
